import { BasicButton, ButtonGroup, PrimaryButton } from "@certn/cascadia";
import { CascadiaJsonFormContext } from "@certn/forms/src/CascadiaJsonFormContext";
import { useContext, useEffect, useState } from "react";
import { FormContext, useSlottedContext } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { ItemProps } from "./types";
import get from "lodash.get";
import set from "lodash/set";
import isEmpty from "lodash/isEmpty";
import { getHasItemEditToggle } from "../utils";

export function ItemEditControls(props: ItemProps) {
  const { path, uischema } = props;
  const { t } = useTranslation();
  const { onSubmit } = useSlottedContext(FormContext) as any;
  const {
    isSummaryForPath,
    setIsSummaryOverride,
    values,
    setValues,
    isSubmitting,
    submitErrors,
    isSummary: globalIsSummary,
  } = useContext(CascadiaJsonFormContext);
  const isSummary = isSummaryForPath?.(path);
  const [initialValues, setInitialValues] = useState<any>();
  const itemEditToggle = getHasItemEditToggle(uischema, globalIsSummary);

  useEffect(() => {
    if (itemEditToggle) {
      setIsSummaryOverride?.(props.path, true);
    }
  }, [itemEditToggle, props.path]);

  useEffect(() => {
    if (isSummary === false) {
      setInitialValues(get(values, path));
    }
  }, [isSummary, path]);

  useEffect(() => {
    if (itemEditToggle && !isSubmitting && isEmpty(submitErrors)) {
      setIsSummaryOverride?.(path, true);
    }
  }, [isSubmitting]);

  const handleCancel = () => {
    setIsSummaryOverride?.(path, true);
    const copiedValues = { ...values };
    set(copiedValues, path, initialValues);
    setValues(copiedValues);
  };

  if (!itemEditToggle) {
    return <></>;
  }

  if (!isSummaryForPath?.(path)) {
    return (
      <ButtonGroup>
        <BasicButton onPress={handleCancel}>{t("Cancel")}</BasicButton>
        <PrimaryButton onPress={onSubmit} type="submit">
          {t("Save changes")}
        </PrimaryButton>
      </ButtonGroup>
    );
  }

  return (
    <BasicButton onPress={() => setIsSummaryOverride?.(path, false)}>
      {t("Edit details")}
    </BasicButton>
  );
}
